import { render } from "./SearchStoreGift.vue?vue&type=template&id=da2ae95c&scoped=true"
import script from "./SearchStoreGift.vue?vue&type=script&lang=js"
export * from "./SearchStoreGift.vue?vue&type=script&lang=js"

import "./SearchStoreGift.vue?vue&type=style&index=0&id=da2ae95c&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2ae95c"]])

export default __exports__